import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

import { formPost } from '@/utils/formUtils';

export function useLogoutUser() {
  const posthog = usePostHog();
  return useCallback(() => {
    posthog.reset();
    formPost('/api/auth/logout', {});
  }, [posthog]);
}
